<div class="px-3 py-2">
	<h4>Workshop - CRYPTANALYSIS: a key tool in securing and breaking ciphers</h4>
	<p>Il giorno 4 Febbario 2020 la costituenda associazione nazionale di crittografia 
		De Componendis Cifris ha avuto il piacere di partecipare con un workshop dal titolo: 
		"CRYPTANALYSIS: a key tool in securing and breaking ciphers" alla quarta edizione di 
		ITASEC20, la conferenza annuale sulla sicurezza informatica organizzata dal Laboratorio 
		Nazionale di Cybersecurity del CINI – Consorzio Interuniversitario Nazionale per 
		l’Informatica che si è tenuta ad Ancona.
	</p>
	<h5>Programma</h5>
	<ul>
		<li>
			<p><b>14:00 - 14:15 Prof. Massimiliano Sala</b><br>
				Università di Trento	<br>
				<i>La De Crifis e la crittanalisi italiana </i>
			</p>
		</li>
		<li>
			<p><b>14:15 - 15:35  Sessione I: Crittografia simmetrica</b></p>
			<ul class="ulSon">
				<li>
					<p>14:15 - 14:40 Prof. Andrea Visconti, Dott. Sergio Polese<br>
						Università di Milano <br>
						<a href="../../../../assets/eventi/2020/Workshop/AVisconti-slide.pdf">Survey: 
							Attacchi alle funzioni hash</a>
					</p>
				</li>
				<li>
					<p>14:40 - 14:55 Dott. Stefano Barbero<br>
						Politecnico di Torino <br>
						<a href="../../../../assets/eventi/2020/Workshop/Barbero-slide.pdf">Methods for 
							rotational cryptanalysis of ARX ciphers</a>
					</p>
				</li>
				<li>
					<p>14:55 - 15:20 Prof. Roberto La Scala<br>
						Università di Bari <br>
						<a href="../../../../assets/eventi/2020/Workshop/LaScala-slide.pdf">Survey: 
							Cifrari ed equazioni alle differenze</a>
					</p>
				</li>
				<li>
					<p>15:20 - 15:35 Dott. Marco Cianfriglia<br>
						CNR Roma	<br>
						<a href="../../../../assets/eventi/2020/Workshop/Cianfriglia-slide">High 
							Performance Computing nella crittoanalisi</a>
					</p>
				</li>
				<li>
					<p>11:10 Capitano di Fregata Daniele Boddi<br>
						Stato Maggiore Difesa - VI Reparto <br>
						<i style="color: green;">Ufficio Sicurezza Sistemi</i>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>15:35 -15:55   Coffee break</b></p></li>
		<li>
			<p><b>15:55 - 17:00  Sessione II: Crittografia a chiave pubblica</b></p>
			<ul class="ulSon">
				<li>
					<p>15:55 - 16:20 Dott. Giordano Santilli<br>
						Università di Trento <br>
						<a href="../../../../assets/eventi/2020/Workshop/Santilli-slide.pdf">A survey 
							on cryptanalysis of elliptic curve cryptography</a>
					</p>
				</li>
				<li>
					<p>16:20 - 16:35 Dott.ssa Domenica Sogiorno<br>
						Università di Bari <br>
						 <a href="../../../../assets/eventi/2020/Workshop/Sogiorno-slide.pdf">Una famiglia 
							di chiavi deboli nel Bitcoin</a>
					</p>
				</li>
				<li>
					<p>16:35 - 17:00 Prof. Michele Elia, Dott. Nadir Murru<br>
						Politecnico di Torino - Università di Torino<br>
						<a href="../../../../assets/eventi/2020/Workshop/Murru-slide.pdf">RSA 
							cryptanalysis and factoring: a survey </a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>17:00 Conclusioni</b></p></li>
	</ul>
	<p>Questo evento è stato coordinato dall'Acting Director della De Componendis 
		Cifris e i seguenti docenti universitari:
	</p>
	<ul>
		Prof. Andrea Visconti - <b>Università di Milano</b>; <br>
		Prof. Marco Pedicini - <b>Università Roma Tre</b>; <br>
		Prof. Roberto La Scala - <b>Università di Bari</b>.
	</ul>
</div>